export default "__VITE_ASSET__C05VCXvS__"